import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, CardBody, Col, Row } from "reactstrap";
import CopyData from "./CopyData";
import DellSupppot from "./DellSupppot";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { getWarrantyBySerials } from "../../services/dellWarranty.service";

interface Props {
    itemName: string;
    indice: number;
}

const ItemCollapsable = ({ itemName, indice }: Props) => {

    const dispatch = useAppDispatch();
    const selectedOrder = useAppSelector(x => x.orders.selectedOrder);
    const [sw, setSw] = useState<boolean>(true);

    const itemDescription = selectedOrder?.itemDescription !== null ? selectedOrder?.itemDescription?.includes(",") ? selectedOrder.itemDescription!.split(",")
        : [selectedOrder?.itemDescription!] : ["n/a"];
    const itemQty = selectedOrder?.itemQuantity !== null ? selectedOrder?.itemQuantity?.includes(",") ? selectedOrder.itemQuantity!.split(",")
        : [selectedOrder?.itemQuantity!] : ["n/a"];
    const serials = selectedOrder?.serialNumbers !== null ? selectedOrder?.serialNumbers?.includes(",") ? selectedOrder.serialNumbers!.split(",")
        : [selectedOrder?.serialNumbers!] : ["n/a"];

    useEffect(() => {
        if (serials.length === 1 && serials[0] === 'n/a') return;

        dispatch(getWarrantyBySerials(serials.toString().trim()));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const qty = itemQty.map(Number);
   
    let serialsTemp: string[] = [];
    let serialsTemp2 = serials;

    if (serials.length > 0) {

        qty.forEach(q => {

            const end = (serialsTemp2.length >= q) ? q : serialsTemp2.length;
            const temp = serialsTemp2.map(s => s.trim()).splice(0, end);
            serialsTemp2 = serialsTemp2.map(s => s.trim()).splice(end);
            serialsTemp.push(temp.toString());

        });
        serialsTemp = serialsTemp.at(indice) !== null ? serialsTemp.at(indice)?.includes(",") ? serialsTemp.at(indice)!.split(",")
            : [serialsTemp.at(indice)!] : [];

    } else {
        serialsTemp.push(serials.toString());
    }


    return (
        <Card className="shadow my-2 fs-5">
            <CardBody>
                <Row className="d-flex flex-column flex-sm-row justify-content-between align-items-center">
                    <Col className="fw-bold text-nowrap ms-sm-5">
                        <label>Name</label>
                        <p className="text-primary">
                            {itemName}
                        </p>
                    </Col>
                    <Col sm={2}>
                        <label className="fw-bold">Quantity</label>
                        <p>
                            {itemQty[indice]}
                        </p>
                    </Col>
                    <Col sm={2}
                        role="button"
                        tabIndex={0}
                        aria-expanded={!sw}
                        aria-label={sw ? `Expand ${itemName} details` : `Collapse ${itemName} details`}
                        onClick={() => setSw(!sw)}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setSw(!sw); } }}
                        className="text-center bcd-pointer"
                    >
                        <FontAwesomeIcon icon={sw ? 'angles-down' : 'angles-up'} size="xl" className='text-info'/>
                    </Col>
                </Row>
                <Card hidden={sw} className="shadow fs-5 fade-in">
                    <CardBody>
                        <Row className="d-flex flex-column flex-sm-row">
                            <Col sm={2} className="fw-bold text-nowrap ms-sm-5 w-25">
                                Description
                            </Col>
                            <Col>
                                <p>
                                    {itemDescription[indice]}
                                </p>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <Card hidden={sw} className="shadow fs-5 fade-in">
                    <CardBody>
                        <Row className="d-flex justify-content-start me-5 pe-3">
                            <Col className="fw-bold mb-3 text-nowrap ms-sm-5 w-25">
                                Serial Numbers
                                {serialsTemp &&
                                    <CopyData data={serialsTemp.toString()}/> }
                            </Col>
                        </Row>
                        { serialsTemp &&
                            serialsTemp.map((se, i) => {
                                return (se
                                    ? <DellSupppot key={se} serial={se} />
                                    : <Row key={`no-serial-${i}`} className="d-flex justify-content-start me-5 pe-3">
                                          <Col className="mb-3 text-nowrap ms-sm-5 w-25">
                                              <span>
                                                  No Serial
                                              </span>
                                          </Col>
                                          <Col className="mb-3">
                                              <span>
                                                  No Support Info
                                              </span>
                                          </Col>
                                          <hr className="ms-sm-5"></hr>
                                      </Row>)
                            }) }
                    </CardBody>
                </Card>
            </CardBody>
        </Card>
  );
};

export default ItemCollapsable;